import { useEffect, useState } from "react";
import ModalBox from "./ModalBox";
import { Button, Col, Input, Row, Spinner } from "reactstrap";
import emojis from "../data/emoji";
import LogoModalHeader from "./LogoModalHeader";
import { useAuth } from "./AuthProvider";
import { updateProfile } from "../service/auth";

function ChooseEmojiModal() {
  const [selectedEmoji, setSelectedEmoji] = useState(emojis[0].name);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [allowToEscape, setAllowToEscape] = useState(false);

  const { navigateStage, authDetails, escapeAuth } = useAuth();

  function handleSelectEmoji(event) {
    const selectedEmoji = event.target.value;
    setSelectedEmoji(selectedEmoji);
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (selectedEmoji) {
      setError("");
      setIsLoading(true);
      updateProfile({ emoji: selectedEmoji })
        .then(() => {
          const authUser = JSON.parse(
            localStorage.getItem("authUser") || "null"
          );
          authUser.emoji = selectedEmoji;
          localStorage.setItem("authUser", JSON.stringify(authUser));
          navigateStage({ emoji: selectedEmoji });
        })
        .catch((error) => {
          setError("Failed to update emoji for profile. Please try again.");
          setAllowToEscape(true);
          console.error("Error updating profile:", error);
        })
        .finally(() => setIsLoading(false));
    }
  }

  useEffect(() => {
    if (authDetails?.emoji) {
      setSelectedEmoji(authDetails.emoji);
    }
  }, [authDetails]);

  return (
    <ModalBox open onClose={escapeAuth} showCloseButton={allowToEscape}>
      <form onSubmit={handleSubmit} className="auth-modal-wrapper">
        <LogoModalHeader />
        <label>Pick an emoji for your profile</label>
        <Row className="g-2">
          {emojis.map((emoji) => (
            <Col xs="3" key={emoji.name} className="text-center">
              <label
                className={`emoji-box ${
                  selectedEmoji === emoji.name ? "selected" : ""
                }`}
              >
                <img src={emoji.src} alt={emoji.name} />
                <Input
                  type="radio"
                  name="emoji"
                  value={emoji.name}
                  onChange={handleSelectEmoji}
                  hidden
                />
              </label>
            </Col>
          ))}
          <p className="input-error col-12">{error}</p>
        </Row>
        <Button
          type="submit"
          color="primary"
          block
          disabled={!selectedEmoji || isLoading}
        >
          {isLoading ? <Spinner size="sm" /> : "Save & Continue"}
        </Button>
      </form>
    </ModalBox>
  );
}

export default ChooseEmojiModal;
